module.exports = __webpack_public_path__ + "media/img/android-icon-48x48-f550ea5b9f26ca151cabfeac520a0bdd.png";